import { categories } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function Footer() {
  const fashionCats = categories.slice(0, 5);
  const wearCats = categories.slice(5, 9);
  const moreCats = categories.slice(9, 12);
  const otherCats = categories.slice(12);

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-2/5">
            <Link to="/" className="cursor-pointer">
              <span className="text-xl font-bold text-background-50 tracking-tight">
                AllChinaBuy <span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed max-w-sm">
              The most complete AllChinaBuy Spreadsheet with trusted sellers,
              product comparisons, and safe buying guides updated for 2026.
            </p>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                Fashion
              </h4>
              <ul className="space-y-2.5">
                {fashionCats.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                Accessories
              </h4>
              <ul className="space-y-2.5">
                {wearCats.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                More
              </h4>
              <ul className="space-y-2.5">
                {moreCats.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                Other
              </h4>
              <ul className="space-y-2.5">
                {otherCats.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} AllChinaBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-300 transition-colors cursor-pointer"
            >
              Privacy Policy
            </a>
            <Link
              to="/"
              className="text-xs text-foreground-500 hover:text-primary-300 transition-colors cursor-pointer"
            >
              Home
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}